// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"643":"af7418a14eec6b37","915":"e32e3afd3e551b48"}[chunkId] + ".js";
};